// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module(__filename, [
    'ui.router',

    require('local_modules/services/supplier').default,
    require('local_modules/directives/alphabet_picker').default,
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('catalog.list', {
        url: '',
        template: require('./template'),
        controller: require('./controller').default,
        controllerAs: 'ctrl',
      }),
    ),
  );

export default __filename;
